import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import LargeSecondaryNavigation from "./LargeSecondaryNavigation";
import {
  getNavActiveItem,
  setNavActiveItem,
  clearNavActiveItem
} from "../../../state/modules/navigation";
import { getViewport } from "../../../state/modules/layout";
import {
  getFeature,
  getFeaturesLoaded
} from "@template/state/modules/features";

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setNavActiveItem, clearNavActiveItem }, dispatch);

const mapStateToProps = state => {
  const marketplaceVintageLinkDesktop = getFeature(
    state,
    "emf-95-desktop-marketplace-clothing-nav-edit"
  );

  const marketplaceVintageLinkMobile = getFeature(
    state,
    "emf-137-mweb-marketplace-clothing-nav-edit"
  );

  return {
    largeNavActiveItemId: getNavActiveItem(state),
    viewport: getViewport(state),
    marketplaceVintageLinkDesktop: marketplaceVintageLinkDesktop,
    marketplaceVintageLinkMobile: marketplaceVintageLinkMobile,
    testIsLoaded: getFeaturesLoaded(state)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LargeSecondaryNavigation);
